module.exports = __webpack_public_path__ + "flyer_background_palms_two_054-7e6cb9bed1124202ac98eaf9ccf7e65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_palms_two_054.jpg
// module id = 1672
// module chunks = 1